<template>
    <tr v-if="Edit===false">
        <td>
            <b-input :hidden="true" type="text" v-model="linea.identifier"></b-input>
            {{ linea.identifier }}
        </td>
        <td cols="2">
            <b-button v-on:click="Edit=true" size="sm" variant="outline-secondary" class="mb-2">
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                <span class="sr-only">Help</span>
            </b-button>

            <b-button v-on:click="deleteLinea" size="sm" variant="outline-danger" class="mb-2">
                <b-icon icon="trash" aria-hidden="true"></b-icon>
                <span class="sr-only">Help</span>
            </b-button>
        </td>
    </tr>
    <!-- EDITA EL REGISTRE -->
    <tr v-else>
        <td>
          <b-form-group label="Producte:" label-for="input-producte">
            <b-form-select
              v-model="linea.producte"
              :options="productesData"
              value-field="productoTitulo"
              text-field="productoTitulo"
              ></b-form-select>
          </b-form-group>
        </td>
           <td cols="2">
                <b-button v-on:click="updateLinea" size="sm" variant="outline-success" class="mb-2">
                    <b-icon icon="check" aria-hidden="true"></b-icon>
                </b-button>
                <b-button @click="cancelForm" size="sm" variant="outline-dark" class="mb-2">
                    <b-icon icon="x-square" aria-hidden="true"></b-icon>
                </b-button>
            </td>
    </tr>
</template>

<script>
export default {
  props: {
    productesData: [],
    linea: {
      identifier: {
        type: String,
        required: true
      }
    }
  },
  data () {
    return {
      Edit: false
    }
  },
  created () {
    this.LineaBeforeEdit = Object.assign({}, this.linea)
  },
  methods: {
    deleteLinea () {
      this.$emit('deleteLinea', this.linea)
    },
    updateLinea () {
      this.Edit = false
      this.$emit('updateLinea', this.linea)
    },
    cancelForm () {
      Object.assign(this.linea, this.LineaBeforeEdit)
      this.Edit = false
    }
  }
}
</script>
